import { Typography } from '@recruit-robin/robin-theme/web-components';
import { memo } from 'react';

import type { QuestionKey, RequirementField } from '../../model';

import { useQuestionStyles } from './Question.styles';

export type QuestionProps = {
  question: RequirementField<unknown>;
  getQuestionText: (questionKey: QuestionKey, isAnswered?: boolean, unit?: string) => string;
  children: React.ReactNode;
  rightAdornment?: React.ReactNode;
};

const QuestionComponent = ({ question, getQuestionText, children, rightAdornment }: QuestionProps) => {
  const classes = useQuestionStyles();

  return (
    <div css={classes.questionGroup}>
      <div css={classes.answerInput}>
        <div css={classes.questionHeader}>
          <Typography variant={(v) => v.heading[6]} color={(c) => c.neutral.variant[70]}>
            {getQuestionText(question.question_key, question.is_answered, question.unit)}
          </Typography>
          {rightAdornment != null && rightAdornment}
        </div>
        {children}
      </div>
    </div>
  );
};

export const Question = memo(QuestionComponent);
